import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ImageSectionHeadComponent } from '../../components/image-section-head/image-section-head.component';
import { WpSectionCode, WpClientCode } from '../../services/http/wordpress/wordpress.interface';
import { WordpressService } from '../../services/http/wordpress/wordpress.service';

@Component({
  selector: 'app-ayuntamientos',
  standalone: true,
  imports: [CommonModule, ImageSectionHeadComponent],
  templateUrl: './ayuntamientos.component.html',
  styleUrl: './ayuntamientos.component.scss'
})
export class AyuntamientosComponent {
  ayuntamientosText = '';
  title = "";
  description = "";
  image = "";

  constructor(
    private readonly wordpressService: WordpressService
  ) {
    this.wordpressService.getPost({section: WpSectionCode.ayuntamientos, client: WpClientCode.genCat}).subscribe((response) => {
      this.ayuntamientosText = response?.content.rendered || '';
      this.title = response?.title.rendered || '';
      this.image = response?.acf.image_url || '';
    });
  }
}
